export interface QuotePlaybackRiskWarning {
    taxPayRisk: string;
    inflation: string;
    claimPensionRisk: string;
    takeOutPensionRisk: string;
    overAllReturnRisk: string;
    riskAndStaticQuestion: any[];
}